import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { ComponentsModule } from '@fi-app/components/components.module';
import { BusinessUnitService } from './business-unit.service';
import { FormsModule } from '@angular/forms';
import { BusinessUnitListComponent } from './business-unit-list/business-unit-list.component';
import { BusinessUnitLockedInformationModule } from './business-unit-locked-information/business-unit-locked-information.module';
import { BusinessUnitEditModule } from './business-unit-edit/business-unit-edit.module';
import { BusinessUnitResolverService } from './business-unit-resolver.service';
import { UIRouterModule } from '@uirouter/angular';
import { FiBusinessUnitStates } from './business-unit-states';
import { BusinessUnitViewDialogComponent } from './business-unit-view-dialog/business-unit-view-dialog.component';
import { FiProfileViewModule } from '@fi-app/components/profile-view/profile-view.module';
import { FiBusinessUnitViewTabGroupComponent } from './business-unit-view-dialog/fi-business-unit-view-tab-group/fi-business-unit-view-tab-group.component';
import { FiBusinessUnitGeneralTabComponent } from './business-unit-view-dialog/fi-business-unit-view-tab-group/fi-business-unit-general-tab/fi-business-unit-general-tab.component';
import { FiBusinessUnitViewContactTabComponent } from './business-unit-view-dialog/fi-business-unit-view-tab-group/fi-business-unit-view-contact-tab/fi-business-unit-view-contact-tab.component';
import { FiBusinessUnitViewOtherTabComponent } from './business-unit-view-dialog/fi-business-unit-view-tab-group/fi-business-unit-view-other-tab/fi-business-unit-view-other-tab.component';
import { MatTabsModule } from '@angular/material/tabs';
import { FiDataFieldViewModule } from '@fi-app/data-field/data-field-view/data-field-view.module';
import { MatIconModule } from '@angular/material/icon';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { MatCardModule } from '@angular/material/card';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        UtilitiesModule,
        ComponentsModule,
        BusinessUnitEditModule,
        BusinessUnitLockedInformationModule,
        UIRouterModule.forChild(FiBusinessUnitStates),
        FiProfileViewModule,
        MatTabsModule,
        FiDataFieldViewModule,
        MatIconModule,
        FiItemsListModule,
        FiLocalSearch2Module,
        MatCardModule,
        FiWrapperTableModule,
        MatSortModule,
        MatTableModule,
    ],
    declarations: [
        BusinessUnitListComponent,
        BusinessUnitViewDialogComponent,
        FiBusinessUnitViewTabGroupComponent,
        FiBusinessUnitGeneralTabComponent,
        FiBusinessUnitViewContactTabComponent,
        FiBusinessUnitViewOtherTabComponent,
    ],
    exports: [BusinessUnitLockedInformationModule, BusinessUnitListComponent],
    providers: [BusinessUnitService, BusinessUnitResolverService],
})
export class BusinessUnitModule {}
